import tw from 'twin.macro';
import 'styled-components/macro';

import { FillBadge } from '../../atoms/badge/Badge';
import { TextButton } from '../../atoms/button/Button';
import { Icon } from '../../atoms/icon/Icon';
import { TagType } from './Tags';

export interface TagProps {
  loading?: boolean;
  onRemove?: (tag: TagType) => void;
  onClick?: (tag: TagType) => void;
  value: string;
}

const visibleRemoveIcon = {
  ...tw`opacity-100 ml-1`,
  width: '0.8rem',
};

export const Tag = ({ loading, onClick, onRemove, value, ...props }: TagProps) => {
  const hashValue = '#' + value;

  return (
    <FillBadge
      css={[onRemove && tw`outline-none hover:bg-primary`, onRemove && { ':hover .icon': visibleRemoveIcon }]}
      tw="mr-1"
      {...props}
    >
      <div css={onClick && tw`hover:cursor-pointer`} onClick={() => onClick?.({ value: hashValue })}>
        {hashValue}
      </div>

      {onRemove &&
        (loading ? (
          <Icon name="circle-loader" role="alert" tw="ml-1 animate-spin" />
        ) : (
          <TextButton
            onClick={() => onRemove({ loading, value })}
            onKeyDown={e => ['Enter', ' '].includes(e.key) && onRemove({ loading, value })}
            tw="hover:text-gray-15"
          >
            <Icon
              name="circle-remove"
              tw="w-0 outline-none opacity-0 transition-all duration-fast"
              css={{ '&:focus': visibleRemoveIcon }}
            />
          </TextButton>
        ))}
    </FillBadge>
  );
};
